import React from 'react';
import { Whisper, Tooltip } from 'rsuite';

import { resolveColor } from '../styles';

// Replaces Tremor's Tracker: a row of equal-width coloured segments, one per
// data point, each with an optional hover tooltip. rsuite Whisper renders the
// tooltip in a portal on document.body (same pattern as StatusBadge in
// GetDeviceBadgeFromStatus.jsx), so it isn't clipped by an ancestor's overflow.
const TrackerBlock = ({ color, tooltip }) => {
  const style = {
    flex: 1,
    height: '100%',
    backgroundColor: resolveColor(color),
  };

  if (!tooltip) return <div style={style} />;

  return (
    <Whisper trigger={['hover', 'focus']} placement="top" speaker={<Tooltip>{tooltip}</Tooltip>}>
      <div tabIndex={0} aria-label={tooltip} style={style} />
    </Whisper>
  );
};

export const StatusTracker = ({ data = [], className, style }) => (
  <div
    className={className}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      height: 40,
      borderRadius: 4,
      overflow: 'hidden',
      ...style,
    }}
  >
    {data.map((item, index) => (
      <TrackerBlock key={item.key ?? index} color={item.color} tooltip={item.tooltip} />
    ))}
  </div>
);
